import React, { useState } from "react";
import { useSelector } from "react-redux";
import { GetSngleNewsletter } from "../../api/newsletterApi/newsletter";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import "./ViewNewsletter.css";

const ViewNewsletter = () => {
  const navigate = useNavigate();
  const [finalData, setFinalData] = useState({
    newsletterTitle: "",
    newsletterDescription: "",
    newsletterContent: "",
    newsletterCoverImage: "",
  });

  const selectedNewsletter = useSelector(
    (state) => state.selectedNewsletter.newsletter
  );

  const fetchNewsletter = async () => {
    try {
      const res = await GetSngleNewsletter(selectedNewsletter);

      const data = res?.data?.result_value;

      if (!data || res?.data?.result !== 1) {
        throw new Error("Invalid newsletter data");
      }

      setFinalData({
        newsletterId: selectedNewsletter,
        newsletterTitle: data.newsletter_title || "",
        newsletterDescription: data.newsletter_description || "",
        newsletterContent: data.newsletter_content || "",
        newsletterCoverImage: data.newsletter_coverImage || "",
      });
    } catch (error) {
      toast.error("Error fetching newsletter data");
      navigate("/adminNewsletter");
    }
  };

  fetchNewsletter();

  function handleBack() {
    navigate("/adminNewsletter");
  }

  return (
    <>
     <div className="role-box">
        <ul className="breadcumb">
          <li className="active" onClick={handleBack}>
            <i className="bi bi-file-earmark-richtext"></i>
             Newsletter
          </li>

          <li className="dash-arrow">/</li>

          <li>
            <span>View Newsletter</span>
          </li>
        </ul>
      </div>
      <div className="newsletter_main_widget">
        <div className="newsletter_preview_widget">
          <div className="newsletter_main_headin_txt">
            <div className="newsLetter_heading">
              <h1>{finalData.newsletterTitle}</h1>
            </div>
            <p className="post_des">{finalData.newsletterDescription}</p>
            <div className="newsletter_preview_cover_img">
              <img
                src={finalData.newsletterCoverImage}
                alt="Article CoverImage"
              />
            </div>

            <div
              className="newsletter_main_headin_txt"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(finalData.newsletterContent),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewNewsletter;
